import React, { useState, useRef } from 'react';
import { CarouselControls } from './CarouselControls';
import { HeroCarouselSlide, CarouselSlideDataProps } from './HeroCarouselSlide';
import './HeroCarousel.scss';
import { useLayoutContext } from '../../providers/LayoutProvider';

export interface HeroCarouselInputs {
    title: string;
    carouselSlideData: CarouselSlideDataProps[];
}

export const HeroCarousel = ({ inputs }: { inputs: HeroCarouselInputs }) => {
    const { heroCarouselRef } = useLayoutContext();
    const [currentSlide, setCurrentSlide] = useState(1);
    const [next, setNext] = useState(1);
    const [direction, setDirection] = useState<string>(`right`);
    const [applyIndexOrder, setApplyIndexOrder] = useState(false);
    const [carouselHeight, setCarouselHeight] = useState(0);

    return (
        <>
            <section className="hero-carousel" ref={heroCarouselRef}>
                <div
                    className="carousel-slides"
                    style={{
                        height: `${carouselHeight}px`,
                    }}
                >
                    {inputs.carouselSlideData.map((slide, index) => (
                        <HeroCarouselSlide
                            key={inputs.title + index}
                            slide={slide}
                            activeSlide={index + 1 === currentSlide}
                            direction={direction}
                            prevSlide={index + 1 < currentSlide}
                            nextSlide={index + 2 === currentSlide + 2}
                            setCarouselHeight={setCarouselHeight}
                        />
                    ))}
                </div>
            </section>
            <CarouselControls
                slideNos={inputs.carouselSlideData.length}
                next={next}
                setNext={setNext}
                currentSlide={currentSlide}
                setCurrentSlide={setCurrentSlide}
                setDirection={setDirection}
                setApplyIndexOrder={setApplyIndexOrder}
            />
        </>
    );
};
